var _filter, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorGrab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 17.6955,
    width: 17.4682,
    x: 1.22148,
    y: 1.9751
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_1_9997"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_9997",
    mode: "normal",
    result: "shape"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.38001 10.2699c-.1-.36996-.2-.84996-.41-1.54996s-.34-.86-.47-1.23-.3-.72-.5-1.18c-.1832-.46995-.33683-.95088-.46-1.44-.08324-.4122.01918-.84014.28-1.17.35886-.35018.87668-.48345 1.36-.35.37865.16559.69907.44073.92.79.29504.47167.53653.97478.72 1.5.28174.71963.48622 1.46716.61 2.23l.09.45s0-1.12 0-1.16c0-1-.06-1.82 0-2.94 0-.13.06-.59.08-.72.02585-.43004.28212-.81252.67-1 .44528-.19979.95469-.19979 1.39999 0 .3986.17843.6647.56401.69 1 0 .11.09 1 .09 1.11v2.17c0 .23 0 1.63 0 1.47.0236-1.31954.1372-2.63594.34-3.94.1185-.40856.406-.74699.79-.93.4749-.18706 1.0145-.09457 1.4.24.2882.31629.4578.72269.48 1.15v1.25 2.12s0 .3 0 .18c.09-.28.19-.54.27-.74s.24-.61.36-.86c.1221-.23834.2591-.46879.41-.69.1568-.25427.3919-.45078.67-.56.2505-.09682.5293-.08885.7739.02212.2445.11098.4341.31562.5261.56788.0595.36425.0595.73575 0 1.1-.0667.55943-.1838 1.11168-.35 1.65-.13.45-.27 1.22996-.34 1.59996s-.23 1.38-.36 1.82c-.1925.5249-.4585 1.0199-.79 1.47-.4852.5403-.8863 1.1504-1.19 1.81-.0747.3279-.1083.6638-.1 1-.0016.3107.0388.6202.12.92-.4088.0436-.8211.0436-1.23 0-.39-.06-.87-.84-1-1.08-.0643-.1288-.196-.2103-.34-.2103s-.2757.0815-.34.2103c-.23.38-.71 1.07-1.05 1.11-.66999.08-2.04999 0-3.13999 0 0 0 .19-1-.23-1.36s-.83-.78-1.14-1.06l-.83-.92c-.28-.36-.63-1.09-1.24-2-.35-.5-1-1.09-1.28-1.58-.23508-.3976-.30337-.87213-.19-1.31996.1698-.59464.76066-.96554 1.37-.86.4635.03054.90192.22146 1.24.54.26771.23164.51836.48229.75.75.16.19.2.28.38.50996.18.23.3.46.21.12",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.38001 10.2699c-.1-.36996-.2-.84996-.41-1.54996s-.34-.86-.47-1.23-.3-.72-.5-1.18c-.1832-.46995-.33683-.95088-.46-1.44-.08324-.4122.01918-.84014.28-1.17.35886-.35018.87668-.48345 1.36-.35.37865.16559.69907.44073.92.79.29504.47167.53653.97478.72 1.5.28174.71963.48622 1.46716.61 2.23l.09.45s0-1.12 0-1.16c0-1-.06-1.82 0-2.94 0-.13.06-.59.08-.72.02585-.43004.28212-.81252.67-1 .44528-.19979.95469-.19979 1.39999 0 .3986.17843.6647.56401.69 1 0 .11.09 1 .09 1.11v2.17c0 .23 0 1.63 0 1.47.0236-1.31954.1372-2.63594.34-3.94.1185-.40856.406-.74699.79-.93.4749-.18706 1.0145-.09457 1.4.24.2882.31629.4578.72269.48 1.15v1.25 2.12s0 .3 0 .18c.09-.28.19-.54.27-.74s.24-.61.36-.86c.1221-.23834.2591-.46879.41-.69.1568-.25427.3919-.45078.67-.56.2505-.09682.5293-.08885.7739.02212.2445.11098.4341.31562.5261.56788.0595.36425.0595.73575 0 1.1-.0667.55943-.1838 1.11168-.35 1.65-.13.45-.27 1.22996-.34 1.59996s-.23 1.38-.36 1.82c-.1925.5249-.4585 1.0199-.79 1.47-.4852.5403-.8863 1.1504-1.19 1.81-.0747.3279-.1083.6638-.1 1-.0016.3107.0388.6202.12.92-.4088.0436-.8211.0436-1.23 0-.39-.06-.87-.84-1-1.08-.0643-.1288-.196-.2103-.34-.2103s-.2757.0815-.34.2103c-.23.38-.71 1.07-1.05 1.11-.66999.08-2.04999 0-3.13999 0 0 0 .19-1-.23-1.36s-.83-.78-1.14-1.06l-.83-.92c-.28-.36-.63-1.09-1.24-2-.35-.5-1-1.09-1.28-1.58-.23508-.3976-.30337-.87213-.19-1.31996.1698-.59464.76066-.96555 1.37-.86.4635.03054.90192.22146 1.24.54.26771.23163.51836.48229.75.75.16.19.2.28.38.50996.18.23.3.46.21.12",
    stroke: "#222124",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#222124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.75 14.4309v-3.4518c0-.2066-.1679-.3741-.375-.3741s-.375.1675-.375.3741v3.4518c0 .2066.1679.3741.375.3741s.375-.1675.375-.3741z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.76 14.4307-.01-3.4536c-.0006-.2061-.169-.3727-.3761-.3721s-.3745.1682-.3739.3743l.01 3.4535c.0006.2062.169.3728.3761.3722s.3745-.1682.3739-.3743z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.00513 10.9798.02 3.4446c.00121.2086.17009.3767.37719.3754.2071-.0012.37401-.1713.3728-.3799l-.02-3.4446c-.00121-.2086-.17008-.3767-.37719-.3754-.2071.0012-.37401.1713-.3728.3799z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorGrab);
export default __webpack_public_path__ + "static/media/cursor-grab.6249c7bc1e6f6b4ddce5665fc7e1d703.svg";
export { ForwardRef as ReactComponent };